import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import ProfilePicker from './pages/ProfilePicker';
import Search from './pages/Search';
import MyList from './pages/MyList';
import Kids from './pages/Kids';
import Admin from './pages/Admin';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import BuddyChat from './components/BuddyChat';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Loader2 } from 'lucide-react';

const SplashLoader = () => (
  <div className="min-h-screen bg-[#141414] flex items-center justify-center">
    <Loader2 className="w-10 h-10 text-[#e11d48] animate-spin" />
  </div>
);

const RequireBrowse = ({ children }) => {
  const { user, currentProfile, loading } = useAuth();
  const location = useLocation();
  if (loading) return <SplashLoader />;
  if (!user) return <Login />;
  if (!currentProfile) return <Navigate to="/profiles" replace state={{ from: location }} />;
  return children;
};

const RequireAdmin = ({ children }) => {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <SplashLoader />;
  if (!user) return <Login />;
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
};

const RootGate = () => {
  const { user, currentProfile, loading } = useAuth();
  if (loading) return <SplashLoader />;
  if (!user) return <Login />;
  if (!currentProfile) return <ProfilePicker />;
  return <Home />;
};

const ProfilesRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return <SplashLoader />;
  if (!user) return <Login />;
  return <ProfilePicker />;
};

const GlobalBuddy = () => {
  const { user, currentProfile } = useAuth();
  if (!user || !currentProfile) return null;
  return <BuddyChat />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/profiles" element={<ProfilesRoute />} />
            <Route path="/search" element={<RequireBrowse><Search /></RequireBrowse>} />
            <Route path="/mylist" element={<RequireBrowse><MyList /></RequireBrowse>} />
            <Route path="/kids" element={<RequireBrowse><Kids /></RequireBrowse>} />
            <Route path="/admin" element={<RequireAdmin><Admin /></RequireAdmin>} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/" element={<RootGate />} />
            <Route path="*" element={<RootGate />} />
          </Routes>
          <GlobalBuddy />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
